var render, staticRenderFns
import script from "./OrderFilter.vue?vue&type=script&lang=js"
export * from "./OrderFilter.vue?vue&type=script&lang=js"
import style0 from "./OrderFilter.vue?vue&type=style&index=0&id=56ef4b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef4b7a",
  null
  
)

export default component.exports